import { comma } from '@/util/format';
import styled, { css } from 'styled-components';

type Props = {
  supplyDate: string;
  touristName: string;
  productAmount: number;
  reason?: string;
};

function CompletedRefundSection({
  supplyDate,
  touristName,
  productAmount,
  reason,
}: Props) {
  return (
    <TouristInfoList>
      <TouristInfoItem>
        <dt>시술 일자</dt>
        <dd>{supplyDate}</dd>
      </TouristInfoItem>
      <TouristInfoItem>
        <dt>고객명</dt>
        <dd>{touristName}</dd>
      </TouristInfoItem>
      <TouristInfoItem>
        <dt>시술금액</dt>
        <dd>{comma(productAmount)}원</dd>
      </TouristInfoItem>
      {reason && (
        <TouristInfoItem isReasonSection>
          <dt>환급 추가 요청 사유</dt>
          <dd>{reason}</dd>
        </TouristInfoItem>
      )}
    </TouristInfoList>
  );
}

const TouristInfoList = styled.ul`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
`;

const TouristInfoItem = styled.div<{ isReasonSection?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;
  color: #80848a;
  font-size: 12px;
  font-weight: 400;
  line-height: 150%;

  dt {
    font-weight: 700;
  }

  ${({ isReasonSection }) =>
    isReasonSection &&
    css`
      flex-direction: column;
      align-items: flex-start;
      gap: 2px;
      width: 100%;
      margin-top: 8px;
      padding-top: 12px;
      border-top: 1px solid #e5e6e8;
    `}
`;

export default CompletedRefundSection;
